import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";
import { trackPageView } from "@/lib/gtag";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Track page view for GA4 SPA navigation
    trackPageView(pathname);
    // PostHog pageview for SPA navigation
    posthog.capture("$pageview", { $current_url: window.location.href });
  }, [pathname]);

  return null;
};
